import React from "react";
import "./PlatformMarkets.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';

const PlatformMarkets = () => {
  const markets = [
    { title: "Forex Trading", icon: "/images/forex-icon.png", desc: "Forex trading involves exchanging currency pairs through buying and selling." },
    { title: "Metals Trading", icon: "/images/metal-icon.png", desc: "Buying and selling precious metals through online platforms is known as metals trading." },
    { title: "Indices Trading", icon: "/images/indices-icon.png", desc: "Indices trading refers to the process of trading stock market indices by buying and selling them." },
    { title: "Commodities Trading", icon: "/images/commodities-icon.png", desc: "Buy and sell energy resources like oil, natural gas, and more." },
    { title: "Crypto Trading", icon: "/images/crypto-icon.png", desc: "Trade cryptocurrencies like Bitcoin, Ethereum, and more in a highly volatile market." }
  ];

  return (
    <div className="platform-section">
      <div className="platform-header">
        <div className="why-choose-overlay">
          <p className='section-highlight'>Markets</p>
          <h1 className='section-heading'>Trading Markets </h1>
        </div>
      </div>
      <Swiper
        slidesPerView={3}
        spaceBetween={20}
        loop={true}
        centeredSlides={true}
        autoplay={{
          delay: 8000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className="platform-grid"
        breakpoints={{
          0: { slidesPerView: 1 },
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >


        {markets.map((market, index) => (
          <SwiperSlide className="platform-card" key={index}>
            <div className="platform-card-content">
              <h2 className="platform-card-title">{market.title}</h2>
              <img className="platform-card-icon" src={market.icon} alt={market.title} />
              <p className="platform-card-desc">{market.desc}</p>
              <a href="https://panel.therisefx.com/login">
                <button className="platform-btn">Start Trading Now</button>
              </a>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default PlatformMarkets;
